import $ from 'jquery';

$('.copylink').click(function() {
    var link = window.location.href;
    $('.copytext').text(link);
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($('.copytext').text()).select();
    document.execCommand("copy");
    $temp.remove();
});